<!--<mat-spinner class="loading-spinner"></mat-spinner>-->

<div class="training-course-contanier">

  <header>

    <a href="/dashboard" style="color: #0c0c3e; zoom:1.2;" [attr.aria-label]="'common.back' | translate"><mat-icon>keyboard_backspace</mat-icon></a>

    <h1>{{ 'dashboard.training-course' | translate }}</h1>

    <p>{{ 'training-course.description' | translate }}</p>

  </header>

  <app-alert-message></app-alert-message>

  <section class="upload-section">
    <h2>{{ 'training-course.upload-title' | translate }}</h2>
    <p class="muted">{{ 'training-course.max-size-note' | translate }}</p>

    <div class="drop-area" (dragover)="$event.preventDefault()" (drop)="onDrop($event)">
      <input type="file" id="pdfInput" accept="application/pdf" (change)="onFileSelected($event)" />
      <label for="pdfInput" class="drop-label">
        <mat-icon>folder</mat-icon>
        <span class="text">{{ 'training-course.drop-prefix' | translate }} <strong>{{ 'training-course.drop-select' | translate }}</strong></span>
        <span class="note">{{ 'training-course.only-pdf' | translate }}</span>
      </label>
    </div>

    <div class="file-info" *ngIf="selectedFileName">
      <span class="file-name">{{ selectedFileName }}</span>
      <button type="button" class="btn upload-btn" (click)="uploadPdf()" [disabled]="isUploading">{{ isUploading ? ('training-course.uploading' | translate) : ('training-course.upload' | translate) }}</button>
    </div>

    @if(company?.badge){

      <div>

        <div class="training-certificate-uploaded">
          <p>{{ 'training-course.certificate-uploaded' | translate }}</p>
        </div>
                            
        <div class="training-download" (click)="downloadPdf()">
          <p>{{ 'training-course.download-certificate' | translate }} <mat-icon>arrow_downward</mat-icon></p>
        </div>

        <div class="training-remove" (click)="removePdf()">
          <p>{{ 'training-course.delete-certificate' | translate }}<mat-icon>delete</mat-icon></p>
        </div>

      </div>

    }
    @else{

      <div class="training-certificate-not-uploaded">
        <p>{{ 'training-course.certificate-not-uploaded' | translate }}</p>
      </div>
      
    }
    <p class="message" *ngIf="uploadMessage">{{ uploadMessage }}</p>
  </section>

</div>
